import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-login',
  imports: [RouterLink, CommonModule, FormsModule, MatButtonModule, MatDividerModule],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login implements OnInit {
  constructor(
    /** Service for setting the browser tab title. */
    private title: Title,
  ) {}

  /**
   * Sets the browser tab title on init.
   * @returns {void}
   */
  ngOnInit(): void {
    this.title.setTitle('Login');
  }

  /** Whether the user has selected a school from the dropdown. Controls form progression. */
  schoolSelected = false;

  /** Email input value bound to the login form. */
  email = '';

  /** Password input value bound to the login form. */
  password = '';

  /** Available schools shown in the school selector — replace with a real service call when the API is ready. */
  schools = [{ id: 'school1', name: 'Benjamin N. Cardozo High School' }];

  /**
   * Updates `schoolSelected` based on whether a school has been chosen.
   * @param {Event} event - The change event from the school select element.
   * @returns {void}
   */
  onSchoolSelect(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.schoolSelected = !!select.value;
  }

  /**
   * Placeholder — not yet implemented.
   * @returns {void}
   */
  onLogin(): void {}
}
